var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "fixed bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center z-10"
    },
    [
      _c("div", { staticClass: "fixed inset-0 transition-opacity" }, [
        _c("div", {
          staticClass: "absolute inset-0 bg-gray-500 opacity-75",
          on: { click: _vm.close }
        })
      ]),
      _c(
        "div",
        {
          staticClass:
            "relative bg-white rounded-lg px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full sm:p-6",
          attrs: {
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": "modal-headline"
          }
        },
        [
          _vm._m(0),
          _vm._m(1),
          _c(
            "div",
            { staticClass: "mt-5 sm:mt-4 sm:flex sm:flex-row-reverse" },
            [
              _c(
                "span",
                {
                  staticClass:
                    "flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto"
                },
                [
                  _c(
                    "button",
                    {
                      staticClass:
                        "inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-indigo-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo transition ease-in-out duration-150 sm:text-sm sm:leading-5",
                      attrs: { type: "button" },
                      on: { click: _vm.gotoPlan }
                    },
                    [_vm._v(" Goto Plans ")]
                  )
                ]
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sm:flex sm:items-start" }, [
      _c(
        "div",
        { staticClass: "mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left" },
        [
          _c(
            "h3",
            {
              staticClass: "text-lg leading-6 font-medium text-gray-900",
              attrs: { id: "modal-headline" }
            },
            [_vm._v(" Its time to upgrade! ")]
          ),
          _c("div", { staticClass: "mt-2" })
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sm:ml-4 mt-4 text-left" }, [
      _c("p", [
        _vm._v(" Hi, It looks like you have exhausted your free plan limit. ")
      ]),
      _c("p", [_vm._v("Please upgrade to send messages")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }